import { firstValueFrom } from 'rxjs';
import type { Board } from '../../types/board';
import { type BoardListStore } from '../../services/board-list.store';
import { type BoardsStore } from '../../services/boards.store';

/** The keyed-create key every blank-board entry shares: a second activation while one is out reuses it (the store's keyed create). */
export const blankBoardKey = (folderId: string | null): string => `rail-blank:${folderId ?? ''}`;

/**
 * The ONE blank-board creation the rail's "Blank board" and the empty state's "Create a new board" both call (adapted from
 * the rail's former inline `createBlank`): one board in the list's current folder, shown in the list once it exists. It
 * returns the saved board, or null when the create failed; the caller decides how to open it and what to say.
 */
export async function createBlankBoard(
  store: Pick<InstanceType<typeof BoardsStore>, 'createBoard'>,
  listStore: Pick<InstanceType<typeof BoardListStore>, 'folderId' | 'ensureVisibleAfterCreate'> | null,
): Promise<Board | null> {
  const folderId = listStore?.folderId() ?? null;
  const board = await firstValueFrom(store.createBoard({ title: 'Untitled board', folderId, key: blankBoardKey(folderId) }));
  if (!board) return null;
  listStore?.ensureVisibleAfterCreate(board.id);
  return board;
}
